import constate from "constate";
import { useState } from "react";
const useEditorValue = () => {
  const [editorValue, setEditorValue] = useState(null);
  return {
    editorValue,
    setEditorValue
  };
};
const [EditorValueProvider, useEditorValueContext] = constate(useEditorValue);
export {
  EditorValueProvider,
  useEditorValueContext
};
